<template>
    <button 
        class="a-about-map-button about-map-button"
        @click="handleClick"
    >
        <span class="about-map-button__powered-text">Powered by</span>
        <svg-icon
            original
            name="icons/mvg-powered"
            class="about-map-button__powered-icon"
        />
    </button>
</template>

<script>
import { mapGetters } from "vuex";
import { EVENTS } from "../../../utils/constants/bus-events-constants";

export default {
    name: 'AAboutMapButton',
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.AAboutMapButton.params`) || {};
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.AAboutMapButton.params') || {};
        },
        params() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.AAboutMapButton.styles`) || {};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.AAboutMapButton.styles') || {};
        },
        styles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        }
    },
    methods: {
        handleClick() {
            this.$bus.$emit(EVENTS.MODALS.OPENING_ABOUT_MODAL);
        }    
    }
}
</script>

<style lang="scss" src="./a-about-map-button.scss" />
